import React, { useState } from 'react';
import { Tabs } from '@b-design/fusion';
import CommonHeader from '@/components/CommonHeader';
import CalculateComponent from '@/components/CalculateComponent';
import WorkflowManagement from './component/workflowManagement';
import MonitoringDashboard from './component/monitoringDashboard';
import $i18n from '../../i18n';
import './index.less';

const breadcrumbConfig = [
  {
    key: 'smartStudio',
    breadcrumbName: $i18n.get({
      id: 'aopf.pages.smartStudio.IntelligentPaintingPlatform',
      dm: '智绘平台',
    }),
    path: '/smartStudio',
  },
];

const SmartStudio: React.FC = () => {
  // 内容区域高度
  const [contentHeight, setContentHeight] = useState(200);

  return (
    <div className="global-filter-list smart-studio-page">
      <CommonHeader
        title={$i18n.get({
          id: 'aopf.pages.smartStudio.IntelligentPaintingPlatform',
          dm: '智绘平台',
        })}
        breadcrumbs={breadcrumbConfig}
      />
      <div className="detail-container">
        <Tabs shape="wrapped">
          <Tabs.Item
            title={$i18n.get({ id: 'aopf.pages.smartStudio.WorkflowManagement', dm: '工作流管理' })}
            key="workflowManagement"
          >
            <WorkflowManagement contentHeight={contentHeight} />
          </Tabs.Item>
          <Tabs.Item
            title={$i18n.get({ id: 'aopf.pages.smartStudio.MonitoringDashboard', dm: '监控大盘' })}
            key="monitoringDashboard"
          >
            <MonitoringDashboard />
          </Tabs.Item>
        </Tabs>

        <CalculateComponent
          otherWidth={280}
          otherHeight={64 + 88 + 34 + 48 + 24 + 32}
          windowChange={(_width, height) => {
            setContentHeight(height);
          }}
        />
      </div>
    </div>
  );
};
export default SmartStudio;
